import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const fakePurchases = ['María G. de Ciudad de México', 'Carlos R. de Bogotá', 'Ana P. de Buenos Aires', 'Diego M. de Lima', 'Sofía L. de Santiago', 'Roberto H. de Medellín', 'Valentina S. de Monterrey', 'Andrés F. de Quito'];
export function LivePurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    minutes: number;
  } | null>(null);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showRandomNotification = () => {
      const randomName = fakePurchases[Math.floor(Math.random() * fakePurchases.length)];
      const randomMinutes = Math.floor(Math.random() * 12) + 1;
      setNotification({
        name: randomName,
        minutes: randomMinutes
      });
      // Hide after 4 seconds
      timeoutId = setTimeout(() => {
        setNotification(null);
        // Schedule next notification between 8-12 seconds
        const nextDelay = Math.floor(Math.random() * 4000) + 8000;
        timeoutId = setTimeout(showRandomNotification, nextDelay);
      }, 4000);
    };
    // Initial delay of 5 seconds
    timeoutId = setTimeout(showRandomNotification, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-165">
      {notification && <motion.div initial={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-24 left-6 md:bottom-6 z-[998]" data-id="element-166">
          <div className="bg-cardBg border border-border rounded-xl p-4 shadow-2xl flex items-start gap-3 max-w-[300px] relative overflow-hidden" data-id="element-167">
            <div className="absolute top-0 left-0 w-1 h-full bg-green" data-id="element-168" />
            <button onClick={() => setNotification(null)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-169">
              ✕
            </button>
            <div className="mt-1 relative flex h-3 w-3 shrink-0" data-id="element-170">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green opacity-75" data-id="element-171"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green" data-id="element-172"></span>
            </div>
            <div data-id="element-173">
              <p className="text-[13px] text-white font-medium leading-tight pr-4" data-id="element-174">
                <span className="font-bold text-orange" data-id="element-175">
                  🛒 {notification.name}
                </span>{' '}
                acaba de comprar
              </p>
              <p className="text-[11px] text-gray-400 mt-1" data-id="element-176">
                hace {notification.minutes} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}